export const toolbarMinmal = {
 options: ["inline", "list"],
 inline: {
    options: ["bold", "italic", "underline", "strikethrough"]
 }
}